import { client } from "api";
import { Department } from "models/Department";

export type GetAllDepartmentsResponse = Department[];

export const getAllDepartments = () =>
  client.get<GetAllDepartmentsResponse>(`/department/list`).then((res) => res.data);
